<template>
<div>
   <div id="searchBar" class="flex">
    <img :src="Logo" alt="">
    <router-link to="" class="searchBar__input">
      <span class="iconfont icon-sousuo"></span><input type="text" placeholder="请输入关键词查询" v-model="search_val" >
      
    </router-link>
    <span v-if="search_btn_show" class="search_btn" @click="search()">搜索</span>
  </div>>

  <div class="content">
      <router-link  :to="{ path: '/itemDetails', query: { service_id: item.id }}" class="storeList flex_center"  v-for="(item,index) in itemList" :key="index">
          <div class="storeList__img"><img :src="item.thumb_frist" alt=""></div>
          <div class="storeList__content">
            <div class="flex storeList__line">
              <div>{{item.title}}</div>             
              
            </div>
            <div class="col_999 fs_12 storeList__subtitle">
               <p>{{item.desc}}</p>
               <p class="itemList_price"><span>￥{{item.price}} 起</span>{{item.itemtime}}分钟/次</p>
              
            </div>
          </div>
        </router-link>
       <router-link :to="{ path: '/storeDetails', query: { id: storeItem.id }}" class="storeList flex_center" v-for="(storeItem,storeIndex) in storeList" :key="storeIndex">
              <div class="storeList__img"><img :src="storeItem.logo" alt=""></div>
              <div class="storeList__content">
                <div class="flex storeList__line">
                  <div>{{storeItem.storename}}</div>
                  <div class="storeList__distance" v-if="storeItem.juli">
                    <span class="iconfont icon-loc-s col_00A29A"></span>
                    <p >{{storeItem.juli}}</p>
                  </div>
                 
                </div>
                <div class="col_999 fs_12 storeList__subtitle">
                  <p>地址：{{storeItem.address}}</p>
                  <p>电话：{{storeItem.tel}}</p>
                </div>
              </div>
            </router-link>
    
       <div class="tab__content">
        <div class="storeList flex_center techList" v-for="(techItem,techIndex) in techList" :key="techIndex">
          <!--技师头像-->
          <div class="tech__headBox" v-if="techItem.type=='2'">
            <img class="tech__headImg seniorTech" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
            <img class="tech__head_crown" src="../../../static/img/crown_icon.png" alt />
          </div>
          <div class="tech__headBox" v-if="techItem.type=='1'">
            <img class="tech__headImg seniorTech seniorTech2" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
            <img class="tech__head_crown" src="../../../static/img/crown_icon2.png" alt />
          </div>
          <div class="tech__headBox" v-if="techItem.type=='0'">
            <img class="tech__headImg" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
          </div>
          <!--技师内容-->
          <div class="storeList__content">
            <div class="flex_center techList__title">
              <span>{{techItem.name}}</span>
              <div class="detail_star">
                <span v-for="(item,index) in 5" :key="index">
                  <van-icon class="star" size="15px" name="star" v-if="techItem.score > index" :color="star_active" />
                  <van-icon class="star" size="15px" name="star" v-else/>
                </span>
              </div>
            </div>
            <div class="col_999 fs_12">
              <p>{{techItem.levelname}}</p>
              <div class="flex techList__line">
                <div>个人编号：{{techItem.num_id}}</div>
                <router-link :to="{ path: '/technicianDetails', query: { tech_id: techItem.id }}"  class="techList__btn">立即预约</router-link>
              </div>
            </div>
          </div>
        </div>
         </div>

  </div>
 </div> 
</template>

<script>
  export default {
    name: "book",
    data() {
      return {
        Logo:'',
        search_btn_show:true,
        active: 0,  //顶部标签当前位置
        star_active: "#F9CE06",   //星星
        //门店列表
        storeList: [
        ],
        //项目列表
        itemList: [

        ],
        //技师列表
        techList: [

        ],
        tech_level:[],
        level_active:0,

        store_loading: false,
        store_finished: true,
        item_loading: false,
        item_finished: true,
        tech_loading: false,
        tech_finished: true,
        lat:0,
        lng:0,
        search_val :'',
      }
    },
   
    created(){
      var that = this;
      this.search_val = this.$route.query.search_val;    
      console.log(this.search_val);
      this.get_logo();
      this.get_search_info();
    },
    methods: {
     
      get_logo(){
     
        this.axios({
            url: this.api.sysset.sysset_shop,
            data:{
              
            }
        }).then((res) => {
            if (res.error === 0) {
              this.sysset  = res.sysset
              this.Logo = res.sysset.logo
            }

        })
      },
     
      get_search_info(){
        var  that = this;
         this.wx.wxgetlocation(result=>{    
          this.axios({
            url: this.api.index.get_search_info,
            data:{
                'search':this.search_val,
                'lat':result.latitude,
                'lng':result.longitude,
            }
            }).then((res) => {
              if (res.error === 0) {
                this.storeList  = res.store_list 
                this.itemList  = res.service_list 
                this.techList  = res.tech_list           
              }

          })
         },()=>{
           this.axios({
           url: this.api.index.get_search_info,
            data:{
              'search':this.search_val,
                'lat':0,
                'lng':0,
            }
            }).then((res) => {
              if (res.error === 0) {
                this.storeList  = res.store_list 
                this.itemList  = res.service_list 
                this.techList  = res.tech_list           
                this.tech_level = res.tech_level
                this.level_active = res.select_level
              }

          })
         });
        
      },
      search(){
          this.get_search_info();
      }
    },
  };
</script>
<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  @import '../../assets/css/item.css';   /*(服务)项目样式*/
  @import '../../assets/css/technician.css';   /*技师样式*/
    #searchBar{
    width: 100%;
    height: 2.5rem;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 66;
    padding: 0 .75rem;
    background: #f4f5f6;
    border-bottom: 1px solid rgba(231,231,231,1);
  }
  #searchBar img{
    width: 2rem;
    margin-right: .5rem;
  }
  .search_btn{
      width: 18%;
      background: #45b9bc;
      margin-left: 0.5rem;
      font-size: 0.75rem;
      padding: 0.25rem;
      border-radius: 0.2rem;
      text-align: center;
      color: white;
  }
  .searchBar__input{
    display: flex;
    align-items: center;
    width: 100%;
    background: #fff;
    border: 1px solid #ededed;
    height: 1.8rem;
    border-radius: .25rem;
  }
  .searchBar__input span{
    margin: 0 .35rem;
    color: #ccc;
    font-size: .9rem;
  }
  .searchBar__input input{
    width: 90%;
    height: 100%;
    font-size: .7rem;
    padding-right: .5rem;
  }
  
  .content{
    top:3rem
  }
  .tab__content{
    padding-top: .25rem;
  }
  .storeList__subtitle{
    margin-top: 0;
  }
  .tech_level{
      background: white;
      margin-top: 0.2rem;
      overflow: hidden;
      text-align: center;

  }
   .evaluate__tabTitle{
      color: #999;
      border: 1px solid #ccc;
      line-height: 1.2rem;
      margin: .45rem .1rem;
      border-radius: 1.2rem;
      font-size: .6rem;
      display: inline-block;
      margin-left: 0.5rem;
  }
  .evaluate__tabTitle span{
    padding: 0.5rem;
  }
  .active {
    color: #45B9BC;
    border-color: rgba(69, 185, 188, .5);
  }
</style>



// WEBPACK FOOTER //
// src/views/index/search.vue